import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = {
  class: "flex flex-col space-y-0.5 ml-3 mr-1.5",
  style: {"line-height":"1 !important"}
}
const _hoisted_3 = { class: "text-xs text-muted" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"15px !important"}
}, "launch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Avatar, {
      style: {"line-height":"1 !important"},
      user: _ctx.params.data.user
    }, null, 8, ["user"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.params.data.user.full_name), 1),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.params.data.user.email), 1)
    ]),
    _createVNode(_component_router_link, {
      to: {
				name: 'ExamParticipationFull',
				params: {
					participationId: _ctx.params.data.id,
					examId: _ctx.eventId ?? '-1', // prevent 'missing required param' bugs
					courseId: _ctx.courseId ?? '-1',
				},
			},
      target: "_blank",
      class: "mt-1.5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Btn, {
          variant: 'icon',
          outline: true,
          class: "p-1",
          size: 'sm'
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}